import axios from 'axios'

export const getContract = (page, type, perPage) => {
  return axios.get(`contract/list/${page}/${type}/${perPage}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const getContractFilter = (page, type, perPage, filter, key) => {
  return axios.get(`contract/filter/${page}/${type}/${perPage}/${filter}/${key}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const getContractById = (id) => {
  return axios.get(`contract/get/${id}`)
    .then(res => {
      let result = {}
      result.data = res.data
      return result
    })
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const getBid = (id) => {
  return axios.get(`bidcontract/${id}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const postContract = (data) => {
  return axios.post('contract/add', data)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const getBidPrice = (id) => {
  return axios.get(`bidpricecontract/get/${id}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const cancelContract = ({id}) => {
  return axios.put('contract/cancel', {id})
    .then(res => {
      return res
    })
    .catch(err => {
      console.log(err, err.response)
      throw err.response
    })
}

export const getContractDetailShipment = (id) => {
  return axios.get(`contract/shipment/${id}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const getContractOnGoing = (id) => {
  return axios.get(`shipment/contract/${id}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const extendContract = (data) => {
  return axios.put('contract/resend_contract', data)
    .then(res => {
      return res
    })
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const getBusinessAgreement = ({id, bidId}) => {
  return axios.get(`contract/display/ba/${id}/${bidId}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const acceptBusinessAgreement = (id, payload) => {
  return axios.put(`contract/accept/ba/${id}`, payload)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const downloadBusinessAgreement = (id, fileName, bidId) => {
  return axios.get(`contract/download/ba/${id}/${bidId}`, {responseType: 'blob'})
    .then(res => {
      let blob = new Blob([res.data], {type: res.headers['content-type']})
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      return res
    })
    .catch(err => {
      console.log('err', err, err)
      throw err.response
    })
}

export const showAgreementContract = ({shipmentId, contractNumber, type, fileName, fileCategory, fileId}) => {
  return axios.get(`file/shipment/download/stream/${shipmentId}/${contractNumber}/${fileId}/${fileCategory}/${type}`, {responseType: 'blob'})
    .then(res => {
      let blob = new Blob([res.data], {type: 'application/pdf'})
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob)
        return
      }
      // for open on new tab
      let newWindow = window.open(window.location.href)
      newWindow.onload = () => {
        newWindow.location = URL.createObjectURL(blob)
      }
      // for download file
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = fileName
      document.body.appendChild(link)
      link.click()

      return res
    })
    .catch(err => {
      console.log('err', err, err)
      throw err.response
    })
}



// WEBPACK FOOTER //
// ./src/api/contract.api.js